export const linkHome = "/"
export const linkAbout = "/about"
export const linkContactUs = "/contact-us"
export const linkOurCommitment = "/our-commitment"
export const linkProductsServices = "/products-services"
export const linkProductsServicesCinema = "/products-services/cinema"
export const linkProductsServicesConcession = "/products-services/concession"
export const linkProductsServicesDigital = "/products-services/digital-products"
export const linkProductsServicesVenue = "/products-services/venues-others"
export const linkNewsroom = "/newsroom"
export const linkLocations = "/locations"
export const linkCareers = "/career"
export const linkInvestor = "/investor-relations"
export const linkInvestorProspectus = "/investor-relations/prospectus"
export const linkInvestorFinancialInformationReport =
  "/investor-relations/financial-information/financial-report"
export const linkInvestorFinancialInformationOverview =
  "/investor-relations/financial-information/financial-overview"
export const linkInvestorDisclosure = "/investor-relations/disclosure"
export const linkInvestorAnnualReport = "/investor-relations/annual-report"
export const linkInvestorShareholderInfo =
  "/investor-relations/shareholder-information"
export const linkInvestorDividendPolicy = "/investor-relations/dividend/policy"
export const linkInvestorDividendHistory =
  "/investor-relations/dividend/history"
export const linkInvestorIrActivities = "/investor-relations/ir-activities"
export const linkInvestorSupplementaryInformationChild =
  "/investor-relations/supplementary-information/child-entity"
export const linkInvestorSupplementaryInformationInstitution =
  "/investor-relations/supplementary-information/supporting-institution"
export const linkGovernance = "/governance"
export const linkGovernanceAgms = "/governance/agms"
export const linkGovernancePublicExpose = "/governance/public-expose"
export const linkGovernanceCodeOfConduct = "/governance/code-of-conduct"
export const linkGovernanceBoardCharter = "/governance/board-charter"
export const linkGovernanceAuditcommittee = "/governance/audit"
export const linkGovernanceNominationRemuneration =
  "/governance/nominasi-remunerasi"
export const linkGovernanceInternalAudit = "/governance/internal-audit"
export const linkGovernanceCorporateSecretary =
  "/governance/corporate-secretary"
export const linkGovernanceArticlesOfAssociation =
  "/governance/articles-of-associations"
